import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from "body-scroll-lock";
import { Subject } from 'rxjs';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
@Component({
  selector: 'app-loader-screen',
  templateUrl: './loader-screen.component.html',
  styleUrls: ['./loader-screen.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    fadeInOnEnterAnimation({duration: 200}),
    fadeOutOnLeaveAnimation({duration: 200, delay: 300})
  ]
})
export class LoaderScreenComponent {
  @Input() target: any
  @Input() isLoading: Subject<boolean>;
 
  disableScroll() {
    if (this.target) {
      disableBodyScroll(this.target.nativeElement);
    }
  }
  enableScroll() {
    if (this.target) {
      enableBodyScroll(this.target.nativeElement);
    }
  }

  ngOnDestroy() {
    clearAllBodyScrollLocks();
  }

  ngOnInit() {
    this.isLoading.subscribe((state: boolean) => {
      if(state) {
        this.disableScroll();
      } else {
        this.enableScroll();
      }
    })
    
  }
}
